export enum MemberUpdateActionEnum {
  None = 0,
  Accept = 1,
  Reject = 2,
}
